import { ref } from 'vue';
import ValidationErrorsClass from '@/assets/js/ValidationErrors.js';

export function useValidationErrors() {
  const validationErrors = ref(null);

  const initValidationErrors = () => {
    return new ValidationErrorsClass();
  };

  const setValidationErrors = (error) => {
    const errors = initValidationErrors();
    errors.extractErrorsFrom(error);
    validationErrors.value = errors.errors;
  };

  const clearValidationErrors = () => {
    validationErrors.value = null;
  };

  // Return refs and functions to be used in the component
  return {
    validationErrors,
    setValidationErrors,
    clearValidationErrors,
  };
}